import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useRevokeTenantApiKey = (companyId: string) => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    isPending: isLoading,
    error,
    reset,
  } = useMutation<unknown, Error, string>({
    mutationFn: keyId => api.delete(`admin/companies/${companyId}/api-keys/${keyId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'companies', companyId, 'api-keys'] });
    },
  });

  return { revokeKey: mutateAsync, isLoading, error, reset };
};
